// La tienda permite que varios componentes accedan y modifiquen el estado sin tener que utilizar props
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import authService from "../services/authService";
import axios from '@/api/axios';

const TOKEN_KEY = "token";
const TOKEN_REFRESH_KEY = "refresh_token";
const EXPIRES_KEY = "expires_token";

export const useAuthStore = defineStore('auth', () => {
    const token = ref(sessionStorage.getItem(TOKEN_KEY) || null);
    const refreshToken = ref(sessionStorage.getItem(TOKEN_REFRESH_KEY) || null);
    const expiresToken = ref(sessionStorage.getItem(EXPIRES_KEY) || null);

    const isAuthenticated = computed(() => {
        const expires = parseInt(expiresToken.value);
        const tokenExists = !!token.value;
        const notExpired = expires && expires > Date.now();
        return tokenExists && notExpired;
    });


    function setSession(authData) {
        token.value = authData.access_token;
        refreshToken.value = authData.refresh_token;
        expiresToken.value = (Date.now() + (authData.expires_in * 1000) - 5000).toString();

        sessionStorage.setItem(TOKEN_KEY, token.value);
        sessionStorage.setItem(TOKEN_REFRESH_KEY, refreshToken.value);
        sessionStorage.setItem(EXPIRES_KEY, expiresToken.value);

        axios.defaults.headers.common["Authorization"] = `Bearer ${token.value}`;
    }

    async function login(email, password) {
        try {
            const response = await authService.login(email, password);

            const data = response?.data || response;
            if (!data?.access_token) throw new Error("Respuesta inválida del servidor");

            setSession(data);
        } catch (error) {
            console.error("Error al iniciar sesión", error);
            throw error;
        }
    }

    async function logout() {
        token.value = null;
        refreshToken.value = null;
        expiresToken.value = null;

        sessionStorage.removeItem(TOKEN_KEY);
        sessionStorage.removeItem(TOKEN_REFRESH_KEY);
        sessionStorage.removeItem(EXPIRES_KEY);

        delete axios.defaults.headers.common["Authorization"];
    }


    return {
        token,
        isAuthenticated,
        login,
        logout
    };
});
